import React from "react";
import * as I from "./Illustration-style";
import BlueButton from "../BlueButton/BlueButon";


export default function Illustration() {

   return (
      <>
         <I.Illustration>
            <I.IllustrationTextPosition>
               <I.IllustrationTitle>
                  Want to build<br /> something amazing?
               </I.IllustrationTitle>
               <I.IllustrationButtonPosition>
                  <BlueButton style={{ color: 'red' }} text={'Get in touch'}></BlueButton>
               </I.IllustrationButtonPosition>
            </I.IllustrationTextPosition>
         </I.Illustration>

      </>
   )
}

